module.exports = __webpack_public_path__ + "img/shop (1).10bdaa5d.png";